module.exports = __webpack_public_path__ + "static/media/mx.8ee3aa6a.svg";